/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiFinalRiskLevel } from './InternalApiFinalRiskLevel';
import {
    InternalApiFinalRiskLevelFromJSON,
    InternalApiFinalRiskLevelFromJSONTyped,
    InternalApiFinalRiskLevelToJSON,
    InternalApiFinalRiskLevelToJSONTyped,
} from './InternalApiFinalRiskLevel';

/**
 * Add risk override
 * @export
 * @interface InternalApiAddFinalRiskOverride
 */
export interface InternalApiAddFinalRiskOverride {
    /**
     * 
     * @type {string}
     * @memberof InternalApiAddFinalRiskOverride
     */
    reasonHandle: string;
    /**
     * 
     * @type {InternalApiFinalRiskLevel}
     * @memberof InternalApiAddFinalRiskOverride
     */
    level: InternalApiFinalRiskLevel;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiAddFinalRiskOverride
     */
    endTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAddFinalRiskOverride
     */
    comment: string;
}



/**
 * Check if a given object implements the InternalApiAddFinalRiskOverride interface.
 */
export function instanceOfInternalApiAddFinalRiskOverride(value: object): value is InternalApiAddFinalRiskOverride {
    if (!('reasonHandle' in value) || value['reasonHandle'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function InternalApiAddFinalRiskOverrideFromJSON(json: any): InternalApiAddFinalRiskOverride {
    return InternalApiAddFinalRiskOverrideFromJSONTyped(json, false);
}

export function InternalApiAddFinalRiskOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAddFinalRiskOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'reasonHandle': json['reasonHandle'],
        'level': InternalApiFinalRiskLevelFromJSON(json['level']),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'comment': json['comment'],
    };
}

export function InternalApiAddFinalRiskOverrideToJSON(json: any): InternalApiAddFinalRiskOverride {
    return InternalApiAddFinalRiskOverrideToJSONTyped(json, false);
}

export function InternalApiAddFinalRiskOverrideToJSONTyped(value?: InternalApiAddFinalRiskOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reasonHandle': value['reasonHandle'],
        'level': InternalApiFinalRiskLevelToJSON(value['level']),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
        'comment': value['comment'],
    };
}

